import { Button, Flex, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { BankingConnectionSuccess } from '../../../../../../assets/images'
import { useOrganizationViewUrl } from '../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../utils/routing/reactRoute'

export const SuccessModalBodyNewFlow = (): ReactElement => {
  const { t } = useTranslation()
  const { url: bankAccountsUrl } = useOrganizationViewUrl(reactRoute.organization.bank.getBankAccountsRoute())

  return (
    <Flex flexDirection="column" alignItems="center">
      <BankingConnectionSuccess />
      <Space size="s16" />
      <Text weight="medium" variant="h3" alignment="center">
        {t('bank_connection.shine_connect_modal.success_state_title')}
      </Text>
      <Space size="s8" />
      <Text variant="bodyLG" colorVariant="discreet" alignment="center">
        {t('bank_connection.shine_connect_modal.success_state_description')}
      </Text>
      <Space size="s32" />
      <Button to={bankAccountsUrl} borderRadius="9999px">
        {t('bank_connection.shine_connect_modal.success_state_button')}
      </Button>
    </Flex>
  )
}
